
import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";

import i18n from '@i18n';

export const initDownloadButton = (lightbox) => {
  const downloadIcon = <MwlIcons icon={'download'} />;

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'download-button',
      ariaLabel: i18n.TOOLBAR.DOWNLOAD,
      order: 10,
      isButton: true,
      html: renderToString(downloadIcon),
      onInit: (el) => {
        el.dataset.tooltip = i18n.TOOLBAR.DOWNLOAD;
      },
      onClick: () => {
        const currSlideData = lightbox.pswp.currSlide.data;
        const href = currSlideData.meta.download;
        const anchor = document.createElement('a');
        anchor.href = href;
        anchor.download = href.split(/[\\/]/).pop();
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },
    });
  });
};